<template>
    <b-modal :title="Core.Definition.getDefinition('Message')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                :ignoreRouteParamId="ignoreRouteParamId"
                v-model="dataId"
                @onInit="onInit"
                @onSave="onSave"
                @onTrashClick="onTrashClick"
                @onRequestSuccess="onRequestSuccess"
                :options="{
                        submit: {
                            text: 'Envoyer',
                            variant: 'success'
                        },
                        reset: {
                            text: 'Réinitialiser',
                            variant: 'light'
                        },
                        trash: {
                            text: 'Supprimer',
                            variant: 'danger'
                        }
                }"
                :getRoot="options.root.get"
                :saveRoot="options.root.save"
                :trashRoot="options.root.trash"
                :formStructure="dataFormStructures.event">
        </DynamicForm>
    </b-modal>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import DynamicForm from './DynamicForm'
    import Alert from './Alert'
    export default {
        name: 'ModalEventMessage',
        components: {
            DynamicForm
        },
        props: {
            ignoreRouteParamId: {
                type: Boolean,
                default: true
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        root: {
                            save: '/event-date-message',
                            get: '/event-date-message',
                            trash: '/event-date-message'
                        }
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(id) {
                    this.dataId = id
                },
                get() {
                    return this.dataId
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataSaveAddArgs: [],
                dataShow: false,
                dataFormStructures: {
                    event: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'isPublic'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'sendToAll'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'userId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'message'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'userId',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Destinataires'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'message',
                                type: 'longText',
                                label: Core.Definition.getDefinition('Message'),
                                value: ''
                            },
                            {
                                id: 'isPublic',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Visible au public'),
                                description: Core.Definition.getDefinition('Si activé, ce message sera lisible par le public dans les informations de l\'événement'),
                                value: false,
                                onChange: function(value, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'sendToAll',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Envoyer à tous les participants'),
                                value: true,
                                onChange: function(val, form, fieldRefs) {
                                    if(val === true) {
                                        fieldRefs['userId'].isVisible = false
                                    } else {
                                        fieldRefs['userId'].isVisible = true
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            addSaveArg(key, value, type) {
                this.dataSaveAddArgs.push({
                    key: key,
                    value: value,
                    type: type
                })
            },
            onSave() {
                for(let saveAddArg in this.dataSaveAddArgs) {
                    saveAddArg = this.dataSaveAddArgs[saveAddArg]
                    this.$refs.dynamicForm.addSaveArg(saveAddArg.key, saveAddArg.value, saveAddArg.type)
                }
                this.$emit('onSave')
            },
            onInit() {
                this.$emit('onInit')
            },
            onTrashClick(id) {
                this.$refs.dynamicForm.trash()
            },
            onRequestSuccess(data, method) {
                switch (method) {
                    case Core.Request.methodGet:
                        this.$emit('onGetSuccess', data)
                        break
                    case Core.Request.methodPost:
                    case Core.Request.methodPut:
                        this.$emit('onSaveSuccess', data)
                        break
                    case Core.Request.methodDelete:
                        this.$emit('onDeleteSuccess', data)
                        break
                }
            }
        }
    }
</script>
